import React, { useCallback, useEffect, useState } from "react";
import { useFormik } from "formik";
import { Button, Col, Form, Row } from "react-bootstrap";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { BiEdit } from "react-icons/bi";
import { VscReplace } from "react-icons/vsc";
import HtmlEditor from "../../../../components/UI/HtmlEditorInput/HtmlEditor";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import useProrrogacaoModal from "./useProrrogacaoModal";
import FormAlert from "../../../../components/UI/FormAlert/FormAlert";
import useExcluirProrrogacaoModal from "./useExcluirProrrogacaoModal";
import useRetornarTextoPadrao from "./useRetornarTextoPadrao";
import useAssinarProrrogacao from "./useAssinarProrrogacao";
import TextSpinner from "../../../../components/UI/Spinner/TextSpinner";
import useSetGuard from "../../../../hooks/useSetGuard";

const validationSchema = Yup.object().shape({
  txProrrogacao: Yup.string().default("").required("Informe o texto do pedido de prorrogação"),
  txJustificativa: Yup.string()
    .default("")
    .required("Informe a justificativa para o pedido de prorrogação")
    .test("valida-just", "Informe a justificativa para o pedido de prorrogação", (value) => {
      if ((value || []).length === 0 || value === undefined || value === null || value === "<p><br></p>") return false;

      return true;
    }),
});
const initialValues = {
  txProrrogacao: "",
  txJustificativa: "",
};
const useSolicitarProrrogacao = ({ dadosOs, pedidoProrrogacao, onUpdate = () => {} }) => {
  const [solicitarProrrogacaoShow, setSolicitarProrrogacaoShow] = useState(false);
  const [ordemServico] = useState(dadosOs.sequencial);
  const [showTexto, setShowTexto] = useState(true);
  const usuario = JSON.parse(localStorage.getItem("user"));
  const setGuardClient = useSetGuard();
  const [desabilitaSalvar, setDesabilitaSalvar] = useState(false);
  const [desabilitaAssinar, setDesabilitaAssinar] = useState(false);

  const { textoPadrao, isLoading: isLoadingTextoPadrao } = useRetornarTextoPadrao();
  const { request, data, errors, isLoading } = useApiClient();
  const handleSubmit = useCallback(
    (values) => {
      if (values.txProrrogacao === "") {
        toast.error("Informe o texto para o pedido de prorrogação.");
        return;
      }
      if (values.txJustificativa === "") {
        toast.error("Informe a justificativa para o pedido de prorrogação.");
        return;
      }
      const params = {
        sqPedidoProrrogacao: pedidoProrrogacao?.sqPedidoProrrogacao ?? 0,
        sqOrdemServico: ordemServico,
        sqAcaoFiscal: dadosOs.acaoFiscal,
        txJustificativa: values.txJustificativa,
        txProrrogacao: values.txProrrogacao,
        nomeAuditor: usuario.nome,
        matriculaAuditor: usuario.matricula,
        siglaOrgaoAuditor: usuario.siglaOrgao,
        sequencialAndamento: pedidoProrrogacao?.sequencialAndamento ?? 0,
      };
      request(apiRoutes.fiscalizacao.prorrogacaoos.solicitarProrrogacaoOs, params);
    },
    [
      pedidoProrrogacao?.sqPedidoProrrogacao,
      ordemServico,
      dadosOs.acaoFiscal,
      usuario.nome,
      usuario.matricula,
      usuario.siglaOrgao,
      pedidoProrrogacao?.sequencialAndamento,
      request,
    ],
  );
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  const { isSubmitting, setSubmitting, setValues, setErrors, setFieldValue } = formik;

  const { ExcluirModal, setShowExcluirConfirm } = useExcluirProrrogacaoModal({
    onUpdate,
    setValues,
    setSolicitarProrrogacaoShow,
  });

  const { AssinarSolicitacao } = useAssinarProrrogacao();

  useEffect(() => {
    setFieldValue(
      "txJustificativa",
      formik.values.txJustificativa ? formik.values.txJustificativa : pedidoProrrogacao?.txJustificativa,
    );
    setFieldValue(
      "txProrrogacao",
      formik.values.txProrrogacao ? formik.values.txProrrogacao.replace("[NUMOS]", ordemServico) : textoPadrao,
    );
  }, [
    textoPadrao,
    setFieldValue,
    formik.values.txProrrogacao,
    ordemServico,
    formik.values.txJustificativa,
    pedidoProrrogacao,
  ]);

  useEffect(() => {
    if ((data || errors) && !isLoading && isSubmitting) {
      setSubmitting(false);
      onUpdate();
      toast.success("Solicitação do Pedido de Prorrogação Salva com sucesso.");
    }
    if (errors && !isLoading) {
      setErrors((curr) => ({ ...curr, ...errors }));
    }
  }, [data, errors, isLoading, isSubmitting, setSubmitting, setValues, setErrors, onUpdate]);

  const { prorrogacaoModal, setProrrogacaoModalShow, setConteudo } = useProrrogacaoModal();

  const preVisualizar = () => {
    const dados = {
      dadosOs,
      textoPadrao: formik.values.txProrrogacao.replace("[NUMOS]", ordemServico).replace("[JUSTIFICATIVA]", ""),
      texto: formik.values.txJustificativa,
    };
    setProrrogacaoModalShow(true);
    setConteudo(dados);
  };

  const solicitarProrrogacao = (
    <div style={{ width: "100%" }}>
      {prorrogacaoModal}
      {ExcluirModal}
      <FormAlert formik={formik} data={data} errors={errors} isLoading={isLoading} />
      <Form noValidate onSubmit={formik.handleSubmit}>
        {isLoadingTextoPadrao ? (
          <TextSpinner />
        ) : (
          <Row style={{ marginBottom: 20, textAlign: "left", width: "100%" }} hidden={!solicitarProrrogacaoShow}>
            <Col>
              <Row className="text-right">
                <Col>
                  {isLoading && <TextSpinner />}
                  <Button
                    variant="primary"
                    className="mr-3 btn btn-primary btn-md"
                    onClick={formik.handleSubmit}
                    disabled={desabilitaSalvar || !formik.isValid}
                  >
                    Salvar
                  </Button>
                  <Button
                    variant="primary"
                    className="mr-3 btn btn-primary btn-md"
                    onClick={() => {
                      AssinarSolicitacao(
                        ordemServico,
                        pedidoProrrogacao,
                        dadosOs.acaoFiscal,
                        usuario,
                        formik.values.txJustificativa,
                        formik.values.txProrrogacao,
                      );
                      setDesabilitaSalvar(true);
                      setDesabilitaAssinar(true);
                    }}
                    disabled={desabilitaAssinar || !formik.isValid}
                  >
                    Assinar
                  </Button>
                  {pedidoProrrogacao?.txJustificativa && (
                    <Button
                      variant="primary"
                      className="mr-3 btn btn-primary btn-md"
                      onClick={() =>
                        setShowExcluirConfirm({
                          show: true,
                          body: `Deseja realmente excluir o Pedido de Solicitação de Prorrogação Nº "${pedidoProrrogacao.sqPedidoProrrogacao}"?`,
                          context: pedidoProrrogacao.sqPedidoProrrogacao,
                        })
                      }
                    >
                      Excluir
                    </Button>
                  )}
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col>
                  <Form.Label style={{ justifyContent: "initial", fontSize: 19 }}>
                    <strong>Justificativa</strong>
                  </Form.Label>
                  <HtmlEditor formik={formik} field="txJustificativa" />
                </Col>
              </Row>
              <Row className="mt-1 text-left">
                <Col>
                  <Form.Label style={{ justifyContent: "initial", fontSize: 19, marginBottom: 10, marginTop: 5 }}>
                    <strong>Texto da Atividade </strong>
                    <BiEdit
                      className="btn-lg  text-danger pa-0 p-0 btn btn-bg-transparent ml-2"
                      title={showTexto ? "Editar Texto" : "Fechar Edição"}
                      size={21}
                      onClick={() => {
                        setShowTexto(!showTexto);

                        if (!showTexto) {
                          setFieldValue("txProrrogacao", textoPadrao);
                        }
                      }}
                    />
                    <VscReplace
                      className="btn-lg  text-danger pa-0 p-0 btn btn-bg-transparent ml-2"
                      title="Visualizar texto com substituições"
                      size={21}
                      onClick={() => preVisualizar()}
                    />
                  </Form.Label>
                  {showTexto ? (
                    "" // removeHTML(formik.values.txProrrogacao)
                  ) : (
                    <HtmlEditor formik={formik} field="txProrrogacao" />
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        )}
      </Form>
    </div>
  );
  return {
    solicitarProrrogacaoShow,
    solicitarProrrogacao,
    setSolicitarProrrogacaoShow,
    setGuardClient,
    isLoading,
  };
};
export default useSolicitarProrrogacao;
